import { PAGINATION_PAGE_SIZE } from "@/constants";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const dataTablePageSizeAtom = atomWithStorage<number>(
	"DataTablePageSize",
	PAGINATION_PAGE_SIZE,
	createJSONStorage(() => localStorage),
	{ getOnInit: true },
);

dataTablePageSizeAtom.debugLabel = "dataTablePageSizeAtom";
